<template>
    <div v-if="proyecto">
        <Box  @close="cerrar(false)">
            <template #top>Modificar Proyecto</template>
            <template #center>
                <div class="nj-cols">
                    <div class="nj-card">
                        <div class="nj-subtitle-1">Datos</div>
                        <div>
                            <div class="nj-cols form c2">
                                <div>
                                    <div class="nj-label">Código</div>
                                    <input type="text" class="nj-text" v-model="proyecto.pry_codigo" ref="pry_codigo">
                                </div>
                                <div>
                                    <div class="nj-label">Nombre</div>
                                    <input type="text" class="nj-text" v-model="proyecto.pry_nombre">
                                </div>
                            </div>
                            <div>
                                <div class="nj-label">Descripción</div>
                                <textarea name="" id="" rows="5" class="nj-textarea" v-model="proyecto.pry_descripcion"></textarea>
                            </div>
                        </div>
                        <br>
                        <div class="nj-subtitle-1">Almacenes</div>
                        <div class="nj-cols form c3">
                            <div>
                                <div class="nj-label">Nombre</div>
                                <input type="text" class="nj-text" v-model="almacen.alm_nombre">
                            </div>
                            <div>
                                <div class="nj-label">Dirección</div>
                                <input type="text" class="nj-text" v-model="almacen.alm_direccion">
                            </div>
                            <div class="nj-flx align-end">
                                <button class="nj-button" @click="agregarAlmacen()">Agregar</button>
                            </div>
                        </div>
                    </div>
                    <div class="nj-card">
                        <div>
                            <div class="nj-empty-box" v-if="!proyecto.almacenes"></div>
                            <b-table v-if="proyecto.almacenes" :data="proyecto.almacenes" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition" :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize"
                                default-sort="" aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                                <template slot-scope="props">
                                    <b-table-column label="Descripción" header-class="is-info">{{ props.row.alm_nombre }}</b-table-column>
                                    <b-table-column label="Dirección" header-class="is-info">{{ props.row.alm_direccion }}</b-table-column>
                                    <b-table-column label="Opciones" header-class="is-info" style="width: 70px;">
                                        <div class="nj-flx">
                                            <button class="nj-button icon c-red" @click="retirarAlmacen(props.row.alm_code)" title="Retirar"><i class="mdi mdi-delete"></i></button>
                                        </div>
                                    </b-table-column>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </template>
            <template #bottom>
                <button class="nj-button c-green" @click="modificar()"><i class="mdi mdi-content-save"></i>Modificar</button>
            </template>
        </Box>
    </div>
</template>

<script>
import { ProyectoService } from "../../services"
import Toast from "../../util/toast"
import { Box } from "../components"

export default {
    name: "ProductoEdit",
    components: {
        Box
    },
    props: {
        pry_id: {
            type: Number
        }
    },
    data() {
        return {
            proyecto: null,
            //
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
            //
            almacen: {
                alm_nombre: null,
                alm_direccion: null
            },
            counter: 0,
        }
    },
    methods: {
        obtener() {
            ProyectoService.obtener(this.pry_id).then(
                response => {
                    this.proyecto = response.data
                    if (this.proyecto.almacenes) {
                        this.proyecto.almacenes.forEach(item => {
                            // agregando un identificador unico para almacen en front-end
                            item.alm_code = `current${item.alm_id}`
                        })
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        agregarAlmacen() {
            let errors = 0
            if (!this.almacen.alm_nombre) errors++
            if (!this.almacen.alm_direccion) errors++
            if (errors == 0) {
                this.proyecto.almacenes.push({
                    // agregando un identificador unico para almacen en front-end
                    alm_code: `new${this.counter}`,
                    alm_nombre: this.almacen.alm_nombre,
                    alm_direccion: this.almacen.alm_direccion,
                })
                this.counter++
                this.almacen.alm_nombre = null
                this.almacen.alm_direccion = null
            } else {
                Toast.error("Debe ingresar todos los datos del almacén")
            }
        },
        modificar() {
            let errores = 0
            if (!this.proyecto.pry_codigo) errores++
            if (!this.proyecto.pry_nombre) errores++
            if (!this.proyecto.pry_descripcion) errores++
            if (!this.proyecto.almacenes) errores++
            if (errores == 0) {
                ProyectoService.modificar(this.proyecto).then(
                    response => {
                        Toast.success(response.message)
                        this.cerrar(true)
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            } else {
                Toast.error("Faltan ingresar datos")
            }
        },
        cerrar(condition) {
            this.$emit("close", condition)
        }
    },
    mounted() {
        this.obtener()
    }
}
</script>

<style scoped></style>